// Section eyebrow removed at client's request — decorative "[NN // LABEL]"
// labels were confusing to visitors. Component returns null so existing call
// sites can keep passing props without further edits.
export default function SectionLabel(_props) {
    return null;
}
